import { render } from "./DigitalSalesComponent.vue?vue&type=template&id=2539f246&scoped=true"
import script from "./DigitalSalesComponent.vue?vue&type=script&lang=js"
export * from "./DigitalSalesComponent.vue?vue&type=script&lang=js"

import "./DigitalSalesComponent.vue?vue&type=style&index=0&id=2539f246&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2539f246"]])

export default __exports__